import { supabase } from '../lib/supabase';

export const signIn = async (email, password) => {
  const { data, error } = await supabase?.auth?.signInWithPassword({ email, password });
  if (error) throw new Error(error.message);
  return data;
};

export const signUp = async (email, password, fullName, role = 'viewer') => {
  const { data, error } = await supabase?.auth?.signUp({
    email,
    password,
    options: { data: { full_name: fullName, role } }
  });
  if (error) throw new Error(error.message);
  return data;
};

export const signOut = async () => {
  const { error } = await supabase?.auth?.signOut();
  if (error) throw new Error(error.message);
};

export const getCurrentUser = async () => {
  const { data: { user } } = await supabase?.auth?.getUser();
  return user;
};

export const getSession = async () => {
  const { data: { session } } = await supabase?.auth?.getSession();
  return session;
};

export const resetPassword = async (email) => {
  const { error } = await supabase?.auth?.resetPasswordForEmail(email);
  if (error) throw new Error(error.message);
};

export const updateUserMetadata = async (updates) => {
  const { data, error } = await supabase?.auth?.updateUser({ data: updates });
  if (error) throw new Error(error.message);
  return data;
};